import React from 'react';

import LoadingImage from '../../../LoadingImage';
import Tag from '../../../Tag';
import StackTags from '../../StackTags';
import SubscriptionTag from '../../../checkout/SubscriptionTag';
import { icons } from '../../../../../helpers/icons';
import { TCourse } from '../../../../../types';
import { useAppSelector } from '../../../../../hooks/hooks';
import { isClassSubscriptionIncluded } from '../../../../../helpers';

interface ICourseDetails {
  course: TCourse;
}

const CourseDetails: React.FC<ICourseDetails> = ({ course }) => {
  const { user } = useAppSelector((state) => state.userReducer);

  const included = isClassSubscriptionIncluded(
    course.nearestStartTime,
    user?.program,
  );

  return (
    <div className="flex flex-col gap-4">
      <div>
        <LoadingImage
          className="rounded-lg w-[6.25rem] h-[6.25rem] object-cover"
          src={course.imageUrl ?? icons.coursePlaceholder}
        />
      </div>
      <div className="text-4xl calistoga text-grey">{course.name}</div>
      {course.skillStacks && (
        <div className="flex flex-wrap gap-2 mb-2">
          <StackTags stacks={course.skillStacks} />
        </div>
      )}
      <div className="flex items-center gap-4">
        {course.priceRange && (
          <div className="text-2xl font-bold text-blue-primary">
            <span className={included ? 'line-through' : ''}>
              {`From ${course.priceRange}`}
            </span>
          </div>
        )}
        {included && <SubscriptionTag />}
      </div>
      <div
        className="inner-html"
        dangerouslySetInnerHTML={{ __html: course.prerequisites }}
      />
      {course.skills.length > 0 && (
        <div className="flex flex-wrap gap-4 text-grey-700">
          {course.skills.map((skill) => (
            <Tag key={skill.id} text={skill.name} color={'blue'} />
          ))}
        </div>
      )}
      {course.whoShouldAttend && (
        <div className="flex flex-col gap-2 p-2 bg-yellow-100">
          <div className="flex items-center gap-2">
            <div>
              <img src={icons.lightBubble} alt="" />
            </div>
            <div className="font-bold text-regular text-grey">
              Who should attend?
            </div>
          </div>
          <div
            className="font-medium text-regular text-core-dark"
            dangerouslySetInnerHTML={{ __html: course.whoShouldAttend }}
          />
        </div>
      )}
    </div>
  );
};

export default CourseDetails;
